import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComputerIcon, NetworkIcon } from "@libs/rubick";
import { ExclamationTriangleIcon, PencilIcon } from "@heroicons/react/24/outline";
export function NodeDetails({ node, onEditClick, onDeleteClick, canDelete }) {
    const hasErrors = node.errors.length > 0;
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-6 pb-6 pt-4 border-t border-gray-200",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-2 gap-4 mb-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-white border border-gray-200 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center justify-between mb-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ _jsx(ComputerIcon, {
                                                className: "w-5 h-5"
                                            }),
                                            /*#__PURE__*/ _jsx("h3", {
                                                className: "text-sm font-semibold text-gray-900",
                                                children: "Basic Information"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex items-center gap-2",
                                        children: onEditClick && /*#__PURE__*/ _jsx("button", {
                                            onClick: onEditClick,
                                            className: "p-1 text-gray-400 hover:text-gray-600 transition-colors rounded hover:bg-gray-100",
                                            "aria-label": "Edit node",
                                            children: /*#__PURE__*/ _jsx(PencilIcon, {
                                                className: "w-4 h-4"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("table", {
                                className: "w-full text-sm",
                                children: /*#__PURE__*/ _jsxs("tbody", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("tr", {
                                            className: "border-b border-gray-100",
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 text-gray-600 text-left",
                                                    children: "Node ID"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 font-medium text-gray-900 text-right",
                                                    children: node.nodeId
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("tr", {
                                            className: "border-b border-gray-100",
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 text-gray-600 text-left",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 font-medium text-gray-900 text-right",
                                                    children: node.description
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("tr", {
                                            className: "border-b border-gray-100",
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 text-gray-600 text-left",
                                                    children: "Location"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 font-medium text-gray-900 text-right",
                                                    children: node.location
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 text-gray-600 text-left",
                                                    children: "Type"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 font-medium text-gray-900 text-right",
                                                    children: node.nodeType
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-white border border-gray-200 rounded-lg p-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2 mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(NetworkIcon, {
                                        className: "w-5 h-5"
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "text-sm font-semibold text-gray-900",
                                        children: "Network Interfaces"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("table", {
                                className: "w-full text-sm",
                                children: /*#__PURE__*/ _jsx("tbody", {
                                    children: node.networkInterfaces.map((iface, index)=>/*#__PURE__*/ _jsxs("tr", {
                                            className: index < node.networkInterfaces.length - 1 ? "border-b border-gray-100" : "",
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 text-gray-600 text-left",
                                                    children: iface.interface
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "py-2 font-mono font-medium text-gray-900 text-right",
                                                    children: iface.ip_address
                                                })
                                            ]
                                        }, iface.interface))
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "bg-white border border-gray-200 rounded-lg p-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(ComputerIcon, {
                                className: "w-5 h-5"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "text-sm font-semibold text-gray-900",
                                children: "Hardware Configuration"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("table", {
                        className: "w-full text-sm",
                        children: /*#__PURE__*/ _jsxs("tbody", {
                            children: [
                                /*#__PURE__*/ _jsxs("tr", {
                                    className: "border-b border-gray-100",
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 text-gray-600 text-left",
                                            children: "Manufacturer"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 font-medium text-gray-900 text-right",
                                            children: node.hardware.manufacturer
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    className: "border-b border-gray-100",
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 text-gray-600 text-left",
                                            children: "Model"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 font-medium text-gray-900 text-right",
                                            children: node.hardware.model
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    className: "border-b border-gray-100",
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 text-gray-600 text-left",
                                            children: "CPU"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 font-medium text-gray-900 text-right",
                                            children: node.hardware.cpu
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    className: "border-b border-gray-100",
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 text-gray-600 text-left",
                                            children: "Memory"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 font-medium text-gray-900 text-right",
                                            children: node.hardware.memory
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 text-gray-600 text-left",
                                            children: "DPU"
                                        }),
                                        /*#__PURE__*/ _jsx("td", {
                                            className: "py-2 font-medium text-gray-900 text-right",
                                            children: node.hardware.hasDPU ? "Present" : "Not Present"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            hasErrors && /*#__PURE__*/ _jsxs("div", {
                className: "bg-red-50 border border-red-200 rounded-lg p-4 mt-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(ExclamationTriangleIcon, {
                                className: "w-5 h-5 text-red-600"
                            }),
                            /*#__PURE__*/ _jsxs("h3", {
                                className: "text-sm font-semibold text-red-800",
                                children: [
                                    "Errors (",
                                    node.errors.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "max-h-64 overflow-y-auto",
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "w-full text-sm",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        className: "border-b border-red-200 text-left sticky top-0 bg-red-50",
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "py-2 pr-3 text-red-700 font-medium",
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "py-2 pr-3 text-red-700 font-medium",
                                                children: "Time"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "py-2 text-red-700 font-medium",
                                                children: "Message"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: node.errors.map((error, index)=>/*#__PURE__*/ _jsx(ErrorRow, {
                                            error: error
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            }),
            canDelete && !node.controlPlane && onDeleteClick && /*#__PURE__*/ _jsx("div", {
                className: "flex justify-end mt-4",
                children: /*#__PURE__*/ _jsx("button", {
                    onClick: onDeleteClick,
                    className: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors",
                    children: "Delete Node"
                })
            })
        ]
    });
}
function formatErrorTime(timestamp) {
    const now = Math.floor(Date.now() / 1000);
    const diffSeconds = now - timestamp;
    if (diffSeconds < 60) return "Just now";
    if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)}m ago`;
    if (diffSeconds < 86400) return `${Math.floor(diffSeconds / 3600)}h ago`;
    return new Date(timestamp * 1000).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}
function ErrorRow({ error }) {
    return /*#__PURE__*/ _jsxs("tr", {
        className: "border-b border-red-100 last:border-b-0",
        children: [
            /*#__PURE__*/ _jsx("td", {
                className: "py-2 pr-3 align-top",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-xs font-medium text-red-800",
                    children: error.source
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "py-2 pr-3 text-red-700 whitespace-nowrap align-top",
                title: new Date(error.timestamp * 1000).toLocaleString(),
                children: formatErrorTime(error.timestamp)
            }),
            /*#__PURE__*/ _jsxs("td", {
                className: "py-2 text-red-900 align-top",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: error.error_msg
                    }),
                    error.command_type && /*#__PURE__*/ _jsxs("span", {
                        className: "block text-xs text-red-600 mt-0.5",
                        children: [
                            "Command: ",
                            error.command_type
                        ]
                    })
                ]
            })
        ]
    });
}
